import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import RepresentativesItemsBlockData from 'app/Models/Content/RepresentativesItemsBlockData';
import RepresentativeItemBlockData from 'app/Models/Content/RepresentativeItemBlockData';
import RepresentativeItemBlock from './RepresentativeItemBlock';
import {getImageProps, getBackgroundImageProps} from 'app/utilities/ImageProps';
import {Container, Row, Col} from 'reactstrap';
import SwiperCore, {Navigation} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import {SwiperOptions} from 'swiper/types/swiper-options';

import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';

SwiperCore.use([Navigation]);

const RepresentativesItemsBlock = (props: ComponentProps<RepresentativesItemsBlockData>) => {
  const {data, context} = props;

  let items = data.items.expandedValue?.map((item: RepresentativeItemBlockData) => ({
    name: item.name?.value,
    email: item.representativeEmailAddress?.value,
    description: item.description?.value,
    iconImage: getBackgroundImageProps(item.iconImage, context),
    image: getImageProps(item.image, context),
    representativeEmailAddress: item.representativeEmailAddress?.value,
  }));

  const swiperOptions: SwiperOptions = {
    slidesPerView: 'auto',
    centerInsufficientSlides: true,
    watchOverflow: true,
    navigation: {nextEl: '.RepresentativesItemsBlock__items__next', prevEl: '.RepresentativesItemsBlock__items__prev'},
  };

  return (
    <Container fluid>
      <Row>
        <Col xs={12} md={12}>
          <div className='RepresentativesItemsBlock'>
            <h2>{data.title.value}</h2>
            <div className='RepresentativesItemsBlock__items'>
              <Image src={require('./images/button-icon-r.svg')} className='RepresentativesItemsBlock__items__prev' />
              <div className='RepresentativesItemsBlock__swiper'>
                <Swiper {...swiperOptions}>
                  {items?.map((itemProps, i) => (
                    <SwiperSlide key={i}>
                      <RepresentativeItemBlock {...itemProps} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
              <Image src={require('./images/button-icon-l.svg')} className='RepresentativesItemsBlock__items__next' />
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default RepresentativesItemsBlock;
